import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NFTList from "../components/NFTList";
import "../styles/Home.css"; // import the CSS

const Home = () => {
  return (
    <>
      {/* Hero Section with Gradient */}
      <header className="home-hero text-center">
        <Container>
          <Row className="align-items-center">
            <Col>
              <h1 className="display-5 fw-bold mb-3">Ghulam Qadir NFT Gallery</h1>
              <p className="lead mb-0">
                Discover curated digital art. Filter by artist, search by name,
                and sort by price — all in a clean, modern UI with vibrant design.
              </p>
            </Col>
          </Row>
        </Container>
      </header>

      {/* NFT Gallery */}
      <div id="gallery">
        <NFTList />
      </div>
    </>
  );
};

export default Home;
